import HighlightClipPlayer from './HighlightClipPlayer';

export default HighlightClipPlayer;
